import { IComponent } from '@websolutespa/bom-core';
import { css } from 'styled-components';
import { OnPageMedia } from '../components/Media/Media';
import theme from '../theme/theme.json';

export const clampValue = (min: number | string, max: number | string) => {
  const minValue = typeof min === 'number' ? min : min.replace('rem', '');
  const maxValue = typeof max === 'number' ? max : max.replace('rem', '');
  return `clamp(${minValue}rem, calc(${minValue}rem + (${maxValue} * 10 - ${minValue} * 10) * (100vw - 375px) / 1545), ${maxValue}rem)`;
};

export const mq = (bp: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | number) => {
  const bpValue = typeof bp === 'number' ? `${bp}px` : theme.mediaQuery[bp];
  return `@media (min-width: ${bpValue})`;
};

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
`;

export const animatedUnderline = (
  thickness: string = '1px',
  duration: string = '0.5s',
  direction: 'ltr' | 'rtl' = 'ltr'
) => css`
  background-image: linear-gradient(currentColor, currentColor);
  background-repeat: no-repeat;
  background-position: ${direction === 'rtl' ? '100%' : '0'} 100%;
  background-size: 0% ${thickness};
  transition: background-size ${duration} ease;
`;

export const getMediaAspectRatio = (
  media: OnPageMedia,
  fallback: number = 16 / 9
) => {
  if (media.width && media.height) {
    return Number(media.width) / Number(media.height);
  }
  return fallback;
};

export const generateOnPageMediaUrl = (
  media: OnPageMedia,
  width: number,
  height: number,
  format: 'webp' | 'jpg' = 'jpg'
) => {
  return `https://storage.onpage.it/${media.token}.${width}x${height}.${format}`;
};

export const withDefaultAnchor = (component: IComponent, { hash, title }: { hash: string; title: string }): IComponent => {
  if (!component.anchor) {
    component.anchor = {
      hash,
      title,
    };
  }
  return component;
};